// ContactUs.js
import './ContactUs.css'; // Import the CSS file
import ImageSlider from '../Home Page/Slideshow';
import React, { useState, useEffect,useRef  } from 'react';
import axios from 'axios';
import '../Move/MajorForms.css'

// Helper function to convert 24-hour format to 12-hour AM/PM format
const convertToAMPM = (time) => {
  const [hours, minutes] = time.split(':');
  let hoursInt = parseInt(hours, 10);
  const suffix = hoursInt >= 12 ? 'PM' : 'AM';
  if (hoursInt > 12) hoursInt -= 12;
  if (hoursInt === 0) hoursInt = 12;
  return `${hoursInt}:${minutes} ${suffix}`;
};
const ContactUs = () => {

  const [locationUrl, setLocationUrl] = useState('');
      const [address, setAddress] = useState('');
      
    // Fetch existing data
    useEffect(() => {
      const fetchLocationData = async () => {
          try {
              const response = await axios.get('https://zoomautos.co.uk/api/location', {
               
              params: {
                _t: new Date().getTime(), // Add timestamp to bypass cache
              },
            
            });
              setLocationUrl(response.data.locationUrl || '');
              setAddress(response.data.address || '');
          } catch (error) {
              console.error('Error fetching location data:', error);
          }
      };
      fetchLocationData();
  }, []);
const [timings, setTimings] = useState([]);
  
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

    
    const [formdata,setFormData]=useState({
      name:'',
      phone:'',
      email:'',
      message:'',
  });

  useEffect(() => {
    fetchTimings();
  }, []);

  const fetchTimings = async () => {
    const response = await fetch('https://zoomautos.co.uk/api/Timings');
    const data = await response.json();
    // Convert times to AM/PM format before setting the state
    const convertedData = data.map((timing) => ({
      ...timing,
      startTime: convertToAMPM(timing.startTime),
      endTime: convertToAMPM(timing.endTime),
    }));
    // Sort timings by the current day of the week
    setTimings(sortTimingsByDay(convertedData));
  };


  // Sort the timings by today's day first, then the rest of the week
// Sort the timings so the list starts with today's day and follows with subsequent days
const sortTimingsByDay = (timings) => {
  const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const currentDayIndex = new Date().getDay();

  // Sort timings based on their day index relative to the current day
  return timings.sort((a, b) => {
    const dayIndexA = daysOfWeek.indexOf(a.day);
    const dayIndexB = daysOfWeek.indexOf(b.day);

    const relativeIndexA = (dayIndexA - currentDayIndex + 7) % 7;
    const relativeIndexB = (dayIndexB - currentDayIndex + 7) % 7;

    return relativeIndexA - relativeIndexB;
  });
};

  const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({
        ...formdata,
        [name]: value,
      });
    };
  
  const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true);

      try{
      const response = await axios.post('https://zoomautos.co.uk/car', {
          formType: 'Message',
          ...formdata,});
      
      
      console.log('Form submitted successfully:', response.data);
      setFormData({
          name:'',
          phone:'',
          email:'',
          message:'',}

      )
  }
      catch(error){
          console.error('Error submitting form:', error.response ? error.response.data : error.message);
    
      }
      setLoading(false);
      setSuccess(true);
  

  };

        const [message, setMessage] = useState('');
       
const [contactNo, setContactNo] = useState('');
  
    // Fetch the contact number on component mount
    useEffect(() => {
      const fetchContact = async () => {
        try {
          setLoading(true);
          const response = await axios.get('https://zoomautos.co.uk/api/contact' , {
           
          params: {
            _t: new Date().getTime(), // Add timestamp to bypass cache
          },
        
        });
          setContactNo(response.data.contactNo || '');
          setLoading(false);
        } catch (error) {
          setLoading(false);
          setMessage('Error fetching contact number');
        }
      };
      fetchContact();
    }, []);
  
  
    return (
      <>
            <h1 style={{marginTop:'100px'}}>CONTACT US</h1>
      
        <div className="contact-container">
            <div className="contact-details">
                <div className="info">
                    <h2>Location</h2>
                    <p>Address:  
            <a 
              href={locationUrl}
              style={{ textDecoration: 'none', color: 'inherit' }} 
              target="_blank" 
              rel="noopener noreferrer"
            >
              {address}
            </a>
          </p>
<h2>Phone</h2>
<p>
            Phone: 
            <a href="tel:${contactNo}" style={{ textDecoration: 'none', color: 'inherit' }}>
              {contactNo}
            </a>
          </p>

                    <h2>Email</h2>
                    <p>
              
              <a href="mailto:info@zoom-autos.co.uk" style={{ textDecoration: 'none', color: 'inherit' }}>
                info@zoom-autos.co.uk
              </a>
            </p>
            <h2>Hours</h2>
      <div className="hours-list">
      {timings.map((timing) => (
          <div key={timing.day}>
            <span>{timing.day}</span>
            <span>{timing.startTime} - {timing.endTime}</span>
          </div>
        ))}
      
      </div>
    

                </div>
                <div className="formss">
                    <h2>Send A Message</h2>
                    <form onSubmit={handleSubmit} >
                                <div >
                                    <input type="text" placeholder="Your Name" name="name" value={formdata.name} onChange={handleChange} required />
                                    <input type="text" placeholder="Your Contact Number"  name="phone" value={formdata.phone} onChange={handleChange}  required />
                                    
                                    <input type="email" placeholder="Your Email" name="email" value= {formdata.email} onChange={handleChange} required />
                                    <textarea placeholder="Message" name="message" value= {formdata.message} onChange={handleChange} required></textarea>
                                    <button className="contact-button" type="submit">
                                        SEND MESSAGE
                                    </button>
                                </div>
                            </form>

                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '20px 0' }}>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3134.341395444745!2d-0.6392963992500774!3d51.48104417765142!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48767b7d2acbdb35%3A0x6ebe77a274d46d4a!2sZoom%20Autos%20Ltd!5e0!3m2!1sen!2s!4v1728914130668!5m2!1sen!2s"
        width="800"
        height="600"
        
        allowFullScreen=""

        referrerPolicy="no-referrer-when-downgrade"
        title="Zoom Autos Location"
      />
    </div>
        </div>

        {loading && (
        <div className='overlayStyle'>
          <div className='loadingStyle'  >Submitting...</div>
        </div>
      )}

      {/* Success Overlay */}
      {success && (
        <div className='overlayStyle'>
          <div className='successStyle' >Thank you For contacting us</div>
        </div>
      )}
        </>
    );
};

export default ContactUs;
